export const RELATED_CONTENT_CONFIG = {
  ASPECT_RATIO: '3:2',
  ITEM_CLASS_NAME: 'mt-2',
  PHOTO_SIZE: 300,
  COLUMN_NUMBER: {
    MOBILE: 2,
    DESKTOP: 3,
  },
  MAX_CONTENT_LENGTH: {
    MOBILE: 6,
    DESKTOP: 6,
  },
};
